/* eslint-disable react-hooks/exhaustive-deps */
import { gql, useLazyQuery } from '@apollo/client';
import { Badge } from '@chakra-ui/react';
import useStore from '../../store';
import { useDebounceEffect } from '../form/useDebounceEffect';
import { useMemo } from 'react';

const QUERY_COUNT_UNREAD_COMPLAINTS = gql`
	query {
		getCountUnreadComplaints
	}
`;
const QUERY_COUNT_UNREAD_COMPLAINTS_ON_INSURANCE = gql`
	query {
		getCountUnreadComplaintsOnInsurance
	}
`;

function ComplaintBadge() {
	const { countUnreadNotifications } = useStore((state) => state?.countUnreadNotifications);
	const [loadCountUnreadComplaints, { data: countComplaintsData }] = useLazyQuery(QUERY_COUNT_UNREAD_COMPLAINTS);
	const [loadCountUnreadComplaintsOnInsurance, { data: countComplaintsOnInsuranceData }] = useLazyQuery(QUERY_COUNT_UNREAD_COMPLAINTS_ON_INSURANCE);

	useDebounceEffect(load, 200, [countUnreadNotifications]);

	const count = useMemo(() => {
		const countComplaints = parseInt(countComplaintsData?.getCountUnreadComplaints || 0);
		const countComplaintsOnInsurance = parseInt(countComplaintsOnInsuranceData?.getCountUnreadComplaintsOnInsurance || 0);
		return countComplaints + countComplaintsOnInsurance;
	}, [countComplaintsData, countComplaintsOnInsuranceData]);

	function load() {
		loadCountUnreadComplaints();
		loadCountUnreadComplaintsOnInsurance();
	}

	return (
		<>
			{parseInt(count) > 0 && (
				<Badge fontSize="x-large" zIndex="99" top="2px" right="2px" position="absolute" colorScheme="red">
					{parseInt(count)}
				</Badge>
			)}
		</>
	);
}

export default ComplaintBadge;
